export default __webpack_public_path__ + "static/media/Rampageous Strike.42e14ae1.png";